var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSistema(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sitemap_fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Development",
    transform: "translate(-960.000000, -48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sitemap_fill",
    transform: "translate(960.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5935,23.2578 L12.5819,23.2595 L12.5109,23.295 L12.4919,23.2987 L12.4767,23.295 L12.4057,23.2595 C12.3958,23.2564 12.387,23.259 12.3821,23.2649 L12.378,23.2758 L12.3609,23.7031 L12.3659,23.7235 L12.3769,23.7357 L12.4805,23.8097 L12.4953,23.8136 L12.5071,23.8097 L12.6107,23.7357 L12.6233,23.7197 L12.6267,23.7031 L12.6096,23.2758 C12.6076,23.2657 12.601,23.2593 12.5935,23.2578 Z M12.8584,23.1453 L12.8445,23.1473 L12.6598,23.2397 L12.6499,23.2499 L12.6472,23.2611 L12.6651,23.6906 L12.6699,23.7034 L12.6784,23.7105 L12.8793,23.8032 C12.8914,23.8069 12.9022,23.803 12.9078,23.7952 L12.9118,23.7812 L12.8777,23.1665 C12.8753,23.1546 12.8674,23.147 12.8584,23.1453 Z M12.143,23.1473 C12.1332,23.1424 12.1222,23.1453 12.1156,23.1526 L12.1099,23.1665 L12.0758,23.7812 C12.0751,23.7927 12.0828,23.8019 12.0926,23.8046 L12.1083,23.8032 L12.3092,23.7105 L12.3186,23.7024 L12.3225,23.6906 L12.3404,23.2611 L12.3372,23.2485 L12.3278,23.2397 L12.143,23.1473 Z",
    id: "MingCute",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,5 C9,3.89543 9.89543,3 11,3 L13,3 C14.1046,3 15,3.89543 15,5 L15,7 C15,8.10457 14.1046,9 13,9 L13,11 L17,11 C18.6569,11 20,12.3431 20,14 L20,15 C21.1046,15 22,15.8954 22,17 L22,19 C22,20.1046 21.1046,21 20,21 L18,21 C16.8954,21 16,20.1046 16,19 L16,17 C16,15.8954 16.8954,15 18,15 L18,14 C18,13.4477 17.5523,13 17,13 L13,13 L13,15 C14.1046,15 15,15.8954 15,17 L15,19 C15,20.1046 14.1046,21 13,21 L11,21 C9.89543,21 9,20.1046 9,19 L9,17 C9,15.8954 9.89543,15 11,15 L11,13 L7,13 C6.44772,13 6,13.4477 6,14 L6,15 C7.10457,15 8,15.8954 8,17 L8,19 C8,20.1046 7.10457,21 6,21 L4,21 C2.89543,21 2,20.1046 2,19 L2,17 C2,15.8954 2.89543,15 4,15 L4,14 C4,12.3431 5.34315,11 7,11 L11,11 L11,9 C9.89543,9 9,8.10457 9,7 L9,5 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#D341D4FF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSistema);
export default __webpack_public_path__ + "static/media/sistema.ed352f3c75a600b9fcd8a9b0fc4e1b2b.svg";
export { ForwardRef as ReactComponent };